import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/actions-runner/_work/Apex/Apex/frontend/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/opt/actions-runner/_work/Apex/Apex/frontend/layouts/public.vue").then(m => m.default || m))
}